import { DOCUMENT_INITIAL_CHARS, DOCUMENT_VALID_CHARS } from "../constants/common.constants";
import { DOCUMENT_REGEX } from "../constants/regex.constants";

/**
 * 
 * @param {string} value 
 * @returns {boolean}
 */
export const validateNIF = (value) => {
	try {
		if (!value || typeof value !== 'string') return false;
		const mayuscValue = value.toUpperCase();

		if (!DOCUMENT_REGEX.DNI.test(mayuscValue)) {
			return false;
		}

		const dni = mayuscValue.substring(0, 8);
		const charIndex = parseInt(dni, 10) % 23;

		return DOCUMENT_VALID_CHARS.charAt(charIndex) === mayuscValue.charAt(8);
	} catch (error) {
		return false;
	}
};

/**
 * 
 * @param {string} value 
 * @returns {boolean}
 */
export const validateNIE = (value) => {
	if (!value || typeof value !== 'string') return false;
	const mayuscValue = value.toUpperCase();
	const firstChar = mayuscValue.charAt(0);	

	if (DOCUMENT_REGEX.NIE.test(mayuscValue) && Object.keys(DOCUMENT_INITIAL_CHARS).includes(firstChar)) {
		return validateNIF(`${DOCUMENT_INITIAL_CHARS[firstChar]}${mayuscValue.substring(1)}`)
	}
	return false;
};

/**
 * 
 * @param {string} pasaporte 
 * @returns {boolean}
 */
export const validatePassport= (pasaporte) => DOCUMENT_REGEX.PASSPORT.test(pasaporte)